import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { FiFilter } from "react-icons/fi";
import toursData from "../../API/tours";
import Loading from "../loading/Loading";
import "./Sidebar.css";

const Sidebar = ({ onFilterChange }) => {
  const location = useLocation();
  const [locationFilter, setLocation] = useState("");
  const [priceRange, setPriceRange] = useState("");
  const [typeOfTour, setTypeOfTour] = useState("");
  const [packageFilter, setPackageFilter] = useState("");
  const [hotel, setHotel] = useState("");
  const [isFilterActive, setIsFilterActive] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [appliedFilters, setAppliedFilters] = useState({});

  const [locations, setLocations] = useState([]);
  const [typeOfTours, setTypeOfTours] = useState([]);
  const [packages, setPackages] = useState([]);
  const [hotels, setHotels] = useState([]);

  useEffect(() => {
    const uniqueLocations = [
      ...new Set(toursData.map((tour) => tour.location).filter((loc) => loc)),
    ];
    setLocations(uniqueLocations);

    const uniqueTypeOfTours = [
      ...new Set(
        toursData.map((tour) => tour.typeOfTour).filter((tour) => tour)
      ),
    ];
    setTypeOfTours(uniqueTypeOfTours);

    const uniquePackages = [
      ...new Set(toursData.map((tour) => tour.package).filter((pkg) => pkg)),
    ];
    setPackages(uniquePackages);

    const uniqueHotels = [
      ...new Set(
        toursData
          .map((tour) => tour.hotel)
          .filter((htl) => htl && htl !== "N/A")
      ),
    ];
    setHotels(uniqueHotels);
  }, []);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const packageFromURL = queryParams.get("package");

    if (packageFromURL) {
      setPackageFilter(packageFromURL);
      setIsFilterActive(true);
    }
  }, [location]);

  const handleFilterChange = () => {
    setLoading(true);
    window.scrollTo(0, 0);
    setTimeout(() => {
      const filters = {
        location: locationFilter || undefined,
        priceRange: priceRange || undefined,
        typeOfTour: typeOfTour || undefined,
        packageFilter: packageFilter || undefined,
        hotel: hotel || undefined,
      };
      onFilterChange(filters);
      setAppliedFilters(filters);
      setIsFilterActive(true);
      setLoading(false);
      setIsOpen(!isOpen);
    }, 500);
  };

  const handleResetFilters = () => {
    setLoading(true); // Start loading

    setLocation("");
    setPriceRange("");
    setTypeOfTour("");
    setPackageFilter("");
    setHotel("");
    onFilterChange({});
    window.scrollTo(0, 0);
    setAppliedFilters({});
    setIsFilterActive(false);

    // Stop loading after 1.5 seconds
    setTimeout(() => {
      setLoading(false);
    }, 500);
  };

  return (
    <>
      <button className="sidebar-toggle" onClick={() => setIsOpen(!isOpen)}>
        <FiFilter size={24} />
        <h3>Filters</h3>
      </button>
      <div className={`sidebar ${isOpen ? "open" : "closed"}`}>
        <h3>Filters</h3>
        {loading && <Loading />}
        <div className="filter-group">
          <label>Price Range:</label>
          <select
            value={priceRange}
            onChange={(e) => setPriceRange(e.target.value)}
          >
            <option value="">All Prices</option>
            <option value="below-5000">Below 5,000</option>
            <option value="5000-10000">5,000 - 10,000</option>
            <option value="10000-15000">10,000 - 15,000</option>
            <option value="above-15000">Above 15,000</option>
          </select>
        </div>
        <div className="filter-group">
          <label>Location:</label>
          <select
            value={locationFilter}
            onChange={(e) => setLocation(e.target.value)}
          >
            <option value="">All Locations</option>
            {locations.map((loc, index) => (
              <option key={index} value={loc}>
                {loc}
              </option>
            ))}
          </select>
        </div>
        <div className="filter-group">
          <label>Type of Tour:</label>
          <select
            value={typeOfTour}
            onChange={(e) => setTypeOfTour(e.target.value)}
          >
            <option value="">All</option>
            {typeOfTours.map((tourType, index) => (
              <option key={index} value={tourType}>
                {tourType}
              </option>
            ))}
          </select>
        </div>
        <div className="filter-group">
          <label>Packages:</label>
          <select
            value={packageFilter}
            onChange={(e) => setPackageFilter(e.target.value)}
          >
            <option value="">All Packages</option>
            {packages.map((pkg, index) => (
              <option key={index} value={pkg}>
                {pkg}
              </option>
            ))}
          </select>
        </div>
        <div className="filter-group">
          <label>Hotel:</label>
          <select value={hotel} onChange={(e) => setHotel(e.target.value)}>
            <option value="">All Hotels</option>
            {hotels.map((htl, index) => (
              <option key={index} value={htl}>
                {htl}
              </option>
            ))}
          </select>
        </div>
        <button
          onClick={handleFilterChange}
          className="filter-button"
          disabled={loading}
        >
          {loading ? "Applying..." : "Apply Filters"}
        </button>
        {isFilterActive && (
          <button
            onClick={handleResetFilters}
            className="reset-button"
            disabled={loading}
          >
            Reset Filters
          </button>
        )}

        <div className="applied-filters">
          <h4>Applied Filters:</h4>
          {Object.keys(appliedFilters).length > 0 ? (
            <ul>
              {Object.entries(appliedFilters).map(
                ([key, value]) =>
                  value && (
                    <li key={key}>
                      <strong>
                        {key
                          .replace(/([A-Z])/g, " $1")
                          .trim()
                          .replace(/^./, (str) => str.toUpperCase())}
                        :
                      </strong>{" "}
                      {value}
                    </li>
                  )
              )}
            </ul>
          ) : (
            <p>No filters applied.</p>
          )}
        </div>
      </div>
    </>
  );
};

export default Sidebar;
